/*
 * productId
 * B2B、B2C: オンライン
 * NORMAL: seat席(Car1, Car2)
 * BOX: box席(Car4)、boxは１つのboxについて1件の予約しかできません、相席などはありません
 *   GRAN: グランシート
 *   GRAN-CHARTER: グランシート(貸切)
 *   GRAN-PLUS: グランシートプラス（box4を貸切)
 *   FULL-CHARTER: 全4つのboxを貸切
 *   詳細については、以下のFigmaを参照してください: https://www.figma.com/design/oAFrf6Y2K1QM3i1ELx7l36/%E3%82%AA%E3%83%B3%E3%83%A9%E3%82%A4%E3%83%B3?node-id=306-5305&t=qLwoK4qeL60gHqMn-0
 */
export enum ProductIdEnum {
  B2B_NORMAL_CAR_1 = '1',
  B2C_NORMAL_CAR_1 = '2',
  B2B_NORMAL_CAR_2 = '3',
  B2C_NORMAL_CAR_2 = '4',
  B2B_BOX_GRAN = '5',
  B2C_BOX_GRAN = '6',
  B2B_BOX_GRAN_CHARTER = '7',
  B2C_BOX_GRAN_CHARTER = '8',
  B2B_BOX_GRAN_PLUS = '9',
  B2C_BOX_GRAN_PLUS = '10',
  B2B_BOX_FULL_CHARTER = '11',
  B2C_BOX_FULL_CHARTER = '12'
}
export type ProductId = `${ProductIdEnum}`;
export const ProductIds = Object.values(ProductIdEnum) as ProductId[];
export const isProductId = (value?: string): value is ProductId =>
  !!value && ProductIds.includes(value.toString() as ProductId);

export const normalCar1ProductIds = [
  ProductIdEnum.B2B_NORMAL_CAR_1,
  ProductIdEnum.B2C_NORMAL_CAR_1
];

export const normalCar2ProductIds = [
  ProductIdEnum.B2B_NORMAL_CAR_2,
  ProductIdEnum.B2C_NORMAL_CAR_2
];

// グランシート、グランシートプラス商品の仕様について
export const boxGranProductIds = [
  ProductIdEnum.B2B_BOX_GRAN,
  ProductIdEnum.B2C_BOX_GRAN
];
export const boxGranCharterProductIds = [
  ProductIdEnum.B2B_BOX_GRAN_CHARTER,
  ProductIdEnum.B2C_BOX_GRAN_CHARTER
];

export const BoxGranPlusProductIds = [
  ProductIdEnum.B2B_BOX_GRAN_PLUS,
  ProductIdEnum.B2C_BOX_GRAN_PLUS
];

// グランシートプラス（貸切)商品: 全ての4boxを貸し切る
export const BoxFullCharterProductIds = [
  ProductIdEnum.B2B_BOX_FULL_CHARTER,
  ProductIdEnum.B2C_BOX_FULL_CHARTER
];

export enum DirectionEnum {
  UP = 'up',
  DOWN = 'down'
}
export type Direction = DirectionEnum;
export const isDirection = (value?: string): value is Direction =>
  !!value &&
  Object.values(DirectionEnum).includes(value.toString() as DirectionEnum);

export enum SeatAdjustmentTypeEnum {
  wheelchair = '3' // 車椅子席
}

export const ArrangementState = {
  Arrangeable: 'ARRANGEABLE',
  Unarrangeable: 'UNARRANGEABLE'
} as const;
export type ArrangementState =
  (typeof ArrangementState)[keyof typeof ArrangementState];

export const MarkState = {
  SeatName: 'SEAT_NAME',
  Hyphone: 'HYPHONE',
  Circle: 'CIRCLE'
} as const;
export type MarkState = (typeof MarkState)[keyof typeof MarkState];

export enum HintTypeEnum {
  Hit = 'HIT',
  OutOfAvailableTerm = 'OUT_OF_AVAILABLE_TERM',
  EndOfService = 'END_OF_SERVICE'
}
export type HintType = HintTypeEnum;
